import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppStatusService } from 'src/app/modules/dashboard/services/app-status.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SECTIONS_PAGE } from 'src/app/Utils/globals';

@Injectable({
  providedIn: 'root',
})
export class RedirectResolver implements Resolve<Observable<any>> {
  constructor(
    private authService: AuthService,
    private router: Router,
    private readonly appStatus: AppStatusService,
  ) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.authService.app.pipe(
      map((app) => {
        for (const sectionKey of Object.keys(SECTIONS_PAGE)) {
          const section = SECTIONS_PAGE[sectionKey];
          if (
            this.authService.visibleSection(section) &&
            this.authService.visibleApp(app.uuid)
          ) {
            this.appStatus.sectionNavigate.next({ link: section });
            this.router.navigate([`${app.uuid}/${section}`]);
            return true;
          }
        }
      }),
    );
  }
}
